// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Offset from "../../resources/layout-and-structure/Offset.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Float from "@rescript/runtime/lib/es6/Stdlib_Float.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as SupplierStatus from "../../modules/Supplier/SupplierStatus.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as SupplierCivility from "../../modules/Supplier/SupplierCivility.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as LegacyResourceList from "../../core/LegacyResourceList.res.js";
import * as SupplierArchiveModal from "../../modules/Supplier/SupplierArchiveModal.res.js";
import * as LegacyResourceListPage from "../../core/LegacyResourceListPage.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["query SupplierListPageQuery($after: String, $before: String, $filterBy: InputSuppliersQueryFilter, $first: Int, $last: Int, $search: String)  {\nsuppliers(after: $after, before: $before, filterBy: $filterBy, first: $first, last: $last, search: $search)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\ntotalCount  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \narchivedAt  \ncompanyName  \ncontacts  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nfirstName  \nlastName  \ncivility  \n}\n\n}\n\n}\n\nemail  \nphoneNumber  \nformattedOrdersTotalAmountIncludingTaxes  \nshop  {\n__typename  \nname  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.suppliers;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    suppliers: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      totalCount: value$1.totalCount,
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.archivedAt;
        let value$3 = value$1.contacts;
        let value$4 = value$3.edges;
        let value$5 = value$1.email;
        let value$6 = value$1.phoneNumber;
        let value$7 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined,
            companyName: value$1.companyName,
            contacts: {
              __typename: value$3.__typename,
              edges: value$4.map(value => {
                let value$1 = value.node;
                let value$2 = value$1.firstName;
                let value$3 = value$1.civility;
                let tmp;
                if (value$3 == null) {
                  tmp = undefined;
                } else {
                  let tmp$1;
                  switch (value$3) {
                    case "MR" :
                      tmp$1 = "MR";
                      break;
                    case "MRS" :
                      tmp$1 = "MRS";
                      break;
                    case "NEUTRAL" :
                      tmp$1 = "NEUTRAL";
                      break;
                    default:
                      throw {
                        RE_EXN_ID: "Not_found",
                        Error: new Error()
                      };
                  }
                  tmp = tmp$1;
                }
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    firstName: !(value$2 == null) ? value$2 : undefined,
                    lastName: value$1.lastName,
                    civility: tmp
                  }
                };
              })
            },
            email: !(value$5 == null) ? value$5 : undefined,
            phoneNumber: !(value$6 == null) ? value$6 : undefined,
            formattedOrdersTotalAmountIncludingTaxes: value$1.formattedOrdersTotalAmountIncludingTaxes,
            shop: {
              __typename: value$7.__typename,
              name: value$7.name
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.suppliers;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.name;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      name: value$3
    };
    let value$5 = value$1.formattedOrdersTotalAmountIncludingTaxes;
    let value$6 = value$1.phoneNumber;
    let phoneNumber = value$6 !== undefined ? value$6 : null;
    let value$7 = value$1.email;
    let email = value$7 !== undefined ? value$7 : null;
    let value$8 = value$1.contacts;
    let value$9 = value$8.edges;
    let edges = value$9.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.civility;
      let civility = value$2 !== undefined ? (
          value$2 === "MR" ? "MR" : (
              value$2 === "MRS" ? "MRS" : "NEUTRAL"
            )
        ) : null;
      let value$3 = value$1.lastName;
      let value$4 = value$1.firstName;
      let firstName = value$4 !== undefined ? value$4 : null;
      let value$5 = value$1.__typename;
      let node = {
        __typename: value$5,
        firstName: firstName,
        lastName: value$3,
        civility: civility
      };
      let value$6 = value.__typename;
      return {
        __typename: value$6,
        node: node
      };
    });
    let value$10 = value$8.__typename;
    let contacts = {
      __typename: value$10,
      edges: edges
    };
    let value$11 = value$1.companyName;
    let value$12 = value$1.archivedAt;
    let archivedAt = value$12 !== undefined ? Scalar.Datetime.serialize(value$12) : null;
    let value$13 = value$1.id;
    let value$14 = value$1.__typename;
    let node = {
      __typename: value$14,
      id: value$13,
      archivedAt: archivedAt,
      companyName: value$11,
      contacts: contacts,
      email: email,
      phoneNumber: phoneNumber,
      formattedOrdersTotalAmountIncludingTaxes: value$5,
      shop: shop
    };
    let value$15 = value.__typename;
    return {
      __typename: value$15,
      node: node
    };
  });
  let value$3 = value$1.totalCount;
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let suppliers = {
    __typename: value$8,
    pageInfo: pageInfo,
    totalCount: value$3,
    edges: edges
  };
  return {
    suppliers: suppliers
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputSuppliersQueryFilter(inp) {
  let a = inp.archived;
  let a$1 = inp.shopIds;
  return {
    archived: a !== undefined ? (
        a === "ONLY" ? "ONLY" : (
            a === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    shopIds: a$1 !== undefined ? serializeInputObjectInFilter(a$1) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.after;
  let a$1 = inp.before;
  let a$2 = inp.filterBy;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.search;
  return {
    after: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    filterBy: a$2 !== undefined ? serializeInputObjectInputSuppliersQueryFilter(a$2) : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    search: a$5 !== undefined ? a$5 : undefined
  };
}

function makeVariables(after, before, filterBy, first, last, search) {
  return {
    after: after,
    before: before,
    filterBy: filterBy,
    first: first,
    last: last,
    search: search
  };
}

function makeInputObjectInputSuppliersQueryFilter(archived, shopIds, param) {
  return {
    archived: archived,
    shopIds: shopIds
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    after: undefined,
    before: undefined,
    filterBy: undefined,
    first: undefined,
    last: undefined,
    search: undefined
  };
}

let SupplierListQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputSuppliersQueryFilter: serializeInputObjectInputSuppliersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputSuppliersQueryFilter: makeInputObjectInputSuppliersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let SupplierListQuery_refetchQueryDescription = include.refetchQueryDescription;

let SupplierListQuery_useLazy = include.useLazy;

let SupplierListQuery_useLazyWithVariables = include.useLazyWithVariables;

let SupplierListQuery = {
  SupplierListQuery_inner: SupplierListQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputSuppliersQueryFilter: serializeInputObjectInputSuppliersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputSuppliersQueryFilter: makeInputObjectInputSuppliersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: SupplierListQuery_refetchQueryDescription,
  use: use,
  useLazy: SupplierListQuery_useLazy,
  useLazyWithVariables: SupplierListQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation unarchiveSupplier($id: ID!)  {\nunarchiveSupplier(id: $id)  {\n__typename  \nid  \narchivedAt  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.unarchiveSupplier;
  let value$2 = value$1.archivedAt;
  return {
    unarchiveSupplier: {
      __typename: value$1.__typename,
      id: value$1.id,
      archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined
    }
  };
}

function serialize$1(value) {
  let value$1 = value.unarchiveSupplier;
  let value$2 = value$1.archivedAt;
  let archivedAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let unarchiveSupplier = {
    __typename: value$4,
    id: value$3,
    archivedAt: archivedAt
  };
  return {
    unarchiveSupplier: unarchiveSupplier
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$1(id, param) {
  return {
    id: id
  };
}

let UnarchiveSupplierMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let UnarchiveSupplierMutation_useWithVariables = include$1.useWithVariables;

let UnarchiveSupplierMutation = {
  UnarchiveSupplierMutation_inner: UnarchiveSupplierMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useWithVariables: UnarchiveSupplierMutation_useWithVariables
};

function jsonCodec(shops) {
  return JsonCodec.object2(param => [
    Stdlib_Option.map(param.shop, shop => shop.id),
    SupplierStatus.toString(param.status)
  ], param => {
    let shopId = param[0];
    return {
      TAG: "Ok",
      _0: {
        shop: shops.find(shop => shop.id === shopId),
        status: SupplierStatus.fromString(param[1])
      }
    };
  }, JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)), JsonCodec.field("status", JsonCodec.string));
}

let SupplierListFilters = {
  jsonCodec: jsonCodec
};

function keyExtractor(value) {
  return value.id;
}

let SupplierTableRow = {
  keyExtractor: keyExtractor
};

function SupplierListPage$SupplierActionsCell(props) {
  let id = props.id;
  let match = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let unarchiveSupplier = match[0];
  let match$1 = React.useState(() => false);
  let setArchiveModalOpened = match$1[1];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Inline.make, {
        children: JsxRuntime.jsxs(MenuActions.make, {
          children: [
            JsxRuntime.jsx(MenuActions.Section.make, {
              children: JsxRuntime.jsx(MenuActions.Item.make, {
                title: I18n.t("See"),
                href: props.supplierShowRoute(id),
                icon: "see_ok"
              })
            }),
            JsxRuntime.jsx(MenuActions.Section.make, {
              children: props.status === "UNARCHIVED" ? JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Archive"),
                  tone: "danger",
                  icon: "archive",
                  onAction: () => setArchiveModalOpened(param => true)
                }) : JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Unarchive"),
                  tone: "brand",
                  icon: "unarchive",
                  onAction: () => {
                    unarchiveSupplier(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
                      id: id
                    });
                  }
                })
            })
          ],
          trigger: {
            TAG: "Compact",
            icon: "more_v2",
            size: "small",
            bold: true
          }
        }),
        align: "end"
      }),
      JsxRuntime.jsx(SupplierArchiveModal.make, {
        id: id,
        opened: match$1[0],
        onRequestClose: () => setArchiveModalOpened(param => false),
        supplierBaseRoute: props.supplierBaseRoute
      })
    ]
  });
}

let SupplierActionsCell = {
  make: SupplierListPage$SupplierActionsCell
};

function supplierTableRowsFromQueryResult(queryResult) {
  return queryResult.suppliers.edges.map(edge => {
    let match = edge.node.archivedAt;
    let match$1 = edge.node.contacts.edges;
    let tmp;
    if (match$1.length !== 1) {
      tmp = undefined;
    } else {
      let edge$1 = match$1[0];
      tmp = edge$1.node.firstName;
    }
    let match$2 = edge.node.contacts.edges;
    let tmp$1;
    if (match$2.length !== 1) {
      tmp$1 = "—";
    } else {
      let edge$2 = match$2[0];
      tmp$1 = edge$2.node.lastName;
    }
    let match$3 = edge.node.contacts.edges;
    let tmp$2;
    if (match$3.length !== 1) {
      tmp$2 = undefined;
    } else {
      let edge$3 = match$3[0];
      tmp$2 = edge$3.node.civility;
    }
    return {
      id: edge.node.id,
      archivedAt: edge.node.archivedAt,
      status: match !== undefined ? "ARCHIVED" : "UNARCHIVED",
      companyName: edge.node.companyName,
      shopName: edge.node.shop.name,
      phoneNumber: edge.node.phoneNumber,
      email: edge.node.email,
      firstName: tmp,
      lastName: tmp$1,
      civility: tmp$2,
      formattedOrdersTotalAmountIncludingTaxes: edge.node.formattedOrdersTotalAmountIncludingTaxes
    };
  });
}

function suppliersQueryVariablesFilterBy(param) {
  let shop = param.shop;
  return {
    archived: param.status === "UNARCHIVED" ? "EXCLUDED" : "ONLY",
    shopIds: shop !== undefined ? ({
        _in: [shop.id]
      }) : undefined
  };
}

function suppliersQueryVariables(param) {
  let connectionArguments = param.connectionArguments;
  return {
    after: connectionArguments.after,
    before: connectionArguments.before,
    filterBy: suppliersQueryVariablesFilterBy(param.filters),
    first: connectionArguments.first,
    last: connectionArguments.last,
    search: param.searchQuery
  };
}

function SupplierListPage(props) {
  let supplierShowRoute = props.supplierShowRoute;
  let supplierBaseRoute = props.supplierBaseRoute;
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let initialFilters = {
    shop: activeShop,
    status: "UNARCHIVED"
  };
  let initialState = LegacyResourceList.initialState(initialFilters);
  let filtersJsonCodec = jsonCodec(shops);
  let resourceListPropState = LegacyResourceList.use(initialState, filtersJsonCodec);
  let dispatch = resourceListPropState[1];
  let state = resourceListPropState[0];
  let queryAsyncResult = ApolloHelpers.queryResultToAsyncResult(use(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, suppliersQueryVariables(state)));
  let onRequestPaginate = React.useCallback(action => {
    let startCursor;
    let endCursor;
    let totalCount;
    if (typeof queryAsyncResult !== "object") {
      return;
    }
    if (queryAsyncResult.TAG === "Reloading") {
      let match = queryAsyncResult._0;
      if (match.TAG !== "Ok") {
        return;
      }
      let match$1 = match._0.suppliers;
      let match$2 = match$1.pageInfo;
      startCursor = match$2.startCursor;
      endCursor = match$2.endCursor;
      totalCount = match$1.totalCount;
    } else {
      let match$3 = queryAsyncResult._0;
      if (match$3.TAG !== "Ok") {
        return;
      }
      let match$4 = match$3._0.suppliers;
      let match$5 = match$4.pageInfo;
      startCursor = match$5.startCursor;
      endCursor = match$5.endCursor;
      totalCount = match$4.totalCount;
    }
    let totalPages = LegacyResourceList.totalPages(totalCount, LegacyResourceList.edgesPerPage);
    let nextPage = LegacyResourceList.nextPage(state, action, totalPages);
    let cursors = [
      startCursor,
      endCursor
    ];
    if (nextPage !== undefined) {
      return dispatch({
        TAG: "Navigated",
        nextPage: nextPage,
        totalCount: totalCount,
        cursors: cursors
      });
    }
  }, [
    state.currentPage,
    queryAsyncResult
  ]);
  let tableColumns = [
    {
      key: "company-name",
      name: I18n.t("Company name"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 200
        },
        width: {
          NAME: "pct",
          VAL: 25
        },
        sticky: true
      },
      render: param => {
        let match = param.data;
        let shopName = shops.length > 1 ? match.shopName : undefined;
        return JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsxs(Stack.make, {
            children: [
              JsxRuntime.jsx(TextLink.make, {
                text: match.companyName,
                to: {
                  TAG: "Route",
                  _0: supplierShowRoute(match.id)
                }
              }),
              shopName !== undefined ? JsxRuntime.jsx(TextStyle.make, {
                  children: shopName,
                  variation: "normal",
                  size: "xxsmall"
                }) : null
            ],
            space: Stdlib_Option.isSome(shopName) ? "xxsmall" : "none"
          }),
          spaceY: "xxsmall"
        });
      }
    },
    {
      key: "contact",
      name: I18n.t("Contact"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 115
        },
        width: {
          NAME: "fr",
          VAL: 1.2
        }
      },
      render: param => {
        let match = param.data;
        let text = Stdlib_Array.filterMap([
          Stdlib_Option.map(match.civility, SupplierCivility.toShortLabel),
          match.firstName,
          match.lastName
        ], maybeString => maybeString).join(" ");
        return JsxRuntime.jsx(TextStyle.make, {
          children: text
        });
      }
    },
    {
      key: "email",
      name: I18n.t("Email address"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 160
        },
        width: {
          NAME: "fr",
          VAL: 1.5
        }
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: Stdlib_Option.getOr(param.data.email, "—")
      })
    },
    {
      key: "phone",
      name: I18n.t("Phone"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 135
        }
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: Stdlib_Option.getOr(param.data.phoneNumber, "—")
      })
    },
    {
      key: "total-purchases-incl",
      name: I18n.t("Total purchases incl."),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 135
        }
      },
      render: param => {
        let amount = Stdlib_Float.fromString(param.data.formattedOrdersTotalAmountIncludingTaxes);
        return JsxRuntime.jsx(TextStyle.make, {
          children: amount !== undefined ? I18n.currencyFormat(undefined, "EUR", 3, 3, amount) : "0"
        });
      }
    },
    {
      key: "actions",
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 70
        },
        width: {
          NAME: "px",
          VAL: 70
        },
        alignX: "flexEnd",
        sticky: true
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(Offset.make, {
          children: JsxRuntime.jsx(SupplierListPage$SupplierActionsCell, {
            id: match.id,
            status: match.status,
            supplierShowRoute: supplierShowRoute,
            supplierBaseRoute: supplierBaseRoute
          }),
          right: 0,
          width: 32,
          height: 32
        });
      }
    }
  ];
  let items = SupplierStatus.values.map(value => ({
    TAG: "Option",
    key: SupplierStatus.toString(value),
    label: SupplierStatus.toLabel(value),
    value: value
  }));
  let match = state.filters.status;
  let filters = JsxRuntime.jsxs(Inline.make, {
    children: [
      shops.length > 1 ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
          value: state.filters.shop,
          onChange: shop => dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: shop,
              status: prev.status
            })
          })
        }) : null,
      shops.length > 1 ? JsxRuntime.jsx(CanarySeparator.make, {}) : null,
      JsxRuntime.jsx(Select.make, {
        label: I18n.t("Status"),
        preset: "filter",
        sections: [{
            items: items
          }],
        value: {
          TAG: "Single",
          _0: state.filters.status
        },
        onChange: change => {
          if (change.TAG !== "Single") {
            return;
          }
          let status = change._0;
          dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: prev.shop,
              status: Stdlib_Option.getExn(status, undefined)
            })
          });
        }
      }),
      match === "ARCHIVED" ? JsxRuntime.jsx(LegacyResourceListPage.ResetFiltersButton.make, {
          onPress: () => dispatch({
            TAG: "FiltersUpdated",
            _0: param => initialState.filters
          })
        }) : null
    ],
    space: "small"
  });
  let actions = JsxRuntime.jsx(Button.make, {
    label: I18n.t("New supplier"),
    variant: "solid",
    tone: "brand",
    size: "legacy_large",
    href: props.supplierNewRoute
  });
  let searchBar = JsxRuntime.jsx(SearchBar.make, {
    placeholder: I18n.t("Search a supplier"),
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let tableEmptyState;
  let exit = 0;
  if (state.currentPage !== 1 || state.searchQuery !== "") {
    exit = 1;
  } else {
    let match$1 = state.filters;
    if (match$1.status === "UNARCHIVED" && match$1.shop === activeShop) {
      tableEmptyState = JsxRuntime.jsx(EmptyState.make, {
        illustration: Illustration.create,
        title: I18n.t("Welcome to the suppliers space.")
      });
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tableEmptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "Reset",
          _0: initialState
        })
      })
    });
  }
  let paginationCurrentPage = state.currentPage;
  let paginationTotalPages;
  if (typeof queryAsyncResult !== "object" || queryAsyncResult.TAG !== "Done") {
    paginationTotalPages = 1;
  } else {
    let match$2 = queryAsyncResult._0;
    paginationTotalPages = match$2.TAG === "Ok" ? LegacyResourceList.totalPages(match$2._0.suppliers.totalCount, LegacyResourceList.edgesPerPage) : 1;
  }
  let tableData = AsyncResult.mapError(AsyncResult.mapOk(queryAsyncResult, supplierTableRowsFromQueryResult), param => {});
  return JsxRuntime.jsx(LegacyResourceListPage.make, {
    title: I18n.t("Suppliers"),
    filters: filters,
    actions: actions,
    searchBar: searchBar,
    tableData: tableData,
    tableColumns: tableColumns,
    tableKeyExtractor: keyExtractor,
    tableEmptyState: tableEmptyState,
    paginationCurrentPage: paginationCurrentPage,
    paginationTotalPages: paginationTotalPages,
    onRequestPaginate: onRequestPaginate
  });
}

let make = SupplierListPage;

export {
  SupplierListQuery,
  UnarchiveSupplierMutation,
  SupplierListFilters,
  SupplierTableRow,
  SupplierActionsCell,
  supplierTableRowsFromQueryResult,
  suppliersQueryVariablesFilterBy,
  suppliersQueryVariables,
  make,
}
/* query Not a pure module */
